import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useAppContext } from '@/contexts/AppContext';
import useAuth from '@/hooks/useAuth';
import FullPageLoading from '../components/FullPageLoading';
import NoLayoutRoute from '../components/routes/NoLayoutRoute';

import GlobalLayout from './GlobalLayout';
import CompanyLayout from './CompanyLayout';

// page
import LoginPage from '@/pages/Auth/LoginPage';
import { UserType } from '@/constants';
import SelectGlobalEntity from '@/pages/GlobalPages/SelectEntity';
import SelectCompanyEntity from '@/pages/CompanyPages/SelectEntity';
import ForgotPassword from '@/pages/Auth/ForgotPasswordPage';
import ResetPassword from '@/pages/Auth/ResetPassword';
import ConfirmEmail from '@/pages/Auth/ConfirmEmail';
import { CompanyUrl } from '@/routers/companyRouters';
import TripStatusTVScreen from '@/pages/CompanyPages/TripStatusTVScreen';
import { PublicRoutes } from '@/routers/publicRoutes';

export default function RenderRoutes() {
  const { auth, authLoaded } = useAppContext();
  const [, i18n] = useTranslation();
  useAuth();
  if (!authLoaded) {
    return <FullPageLoading loading={true} />;
  }

  const session = auth ? (
    auth.userType === UserType.GlobalUser ? (
      <Switch>
        <Route path="/cms/" component={SelectGlobalEntity} exact={true} />
        <Route path="/cms/" component={GlobalLayout} />
      </Switch>
    ) : (
      <Switch>
        <Route path={CompanyUrl.Selling.TripStatusTVScreen} component={TripStatusTVScreen} exact={true} />
        <Route path="/cms/" component={SelectCompanyEntity} exact={true} />
        <Route path="/cms/" component={CompanyLayout} />
      </Switch>
    )
  ) : (
    <Switch>
      <NoLayoutRoute exact path={PublicRoutes.Login} component={LoginPage} />
      <NoLayoutRoute exact path={PublicRoutes.ForgotPassword} component={ForgotPassword} />

      <Redirect from="*" to={PublicRoutes.Login} />
    </Switch>
  );

  return (
    <>
      <Helmet htmlAttributes={{ lang: i18n.language }} />
      {/* Liens reçus par e-mail (réinitialisation, confirmation) : servis même avec une session ouverte (sinon renvoyés vers /cms). */}
      <Switch>
        <NoLayoutRoute exact path={PublicRoutes.ResetPassword} component={ResetPassword} />
        <NoLayoutRoute exact path={PublicRoutes.ConfirmEmail} component={ConfirmEmail} />
        <Route>{session}</Route>
      </Switch>
    </>
  );
}
